import { useEffect } from 'react';
import { useNavigate, useRoutes, useLocation, type NavigateFunction } from 'react-router-dom';
import routes from './config';
import { ChatProvider } from '../hooks/useChat';
import ChatWidget from '../components/feature/ChatWidget';
import { setHomeMotion } from '../components/providers/MotionProvider';

let resolveNavigate: ((navigate: NavigateFunction) => void) | null = null;

declare global {
  interface Window {
    REACT_APP_NAVIGATE?: NavigateFunction;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  resolveNavigate = resolve;
});

export function AppRoutes() {
  const navigate = useNavigate();
  const location = useLocation();
  const element = useRoutes(routes);

  // Motion only on the home page. Set synchronously during render (idempotent
  // global flag) so it is already correct when the page's components mount and
  // start their entrance animations.
  setHomeMotion(location.pathname);

  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    if (resolveNavigate) {
      resolveNavigate(navigate);
      resolveNavigate = null;
    }
  }, [navigate]);

  // Jump to the top on route change (instant — no animated scroll).
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location.pathname]);

  return (
    <ChatProvider>
      {/* Fallback skip-link target. The nav's "Skip to content" link moves focus
          to the page's own <main> (most carry id="main-content"); a page without
          one lands here. A focusable wrapper, not a second <main>, to avoid
          duplicate landmarks, and its own id, so #main-content stays unique. */}
      <div id="page-content" tabIndex={-1} className="outline-none">
        {element}
      </div>
      <ChatWidget />
    </ChatProvider>
  );
}
